import React from 'react';
import foldStyle from './style';

export default function CustumButton({action}) {
	let style = foldStyle();
	return (
		<button style={style.buttonStyle()} onClick={action}>
			I want change!
		</button>
	);
}
